import { TransformedEvent } from "../../Utils/ParsingUtil";
import moment from "moment";
import {removeHtmlTags} from "../../Utils/pdf/utillsPdf";

export function createSingleMeeting(data: TransformedEvent) {
  let description = `
 ${data.resource.description.trim()}
      \\n
      \\n
 Mehr Infos finden Sie hier:
  `;
    data.resource.link.forEach((link: string) => {
      let href = link.split("|")[0];
      let short_title = link.split("|")[1];
      description += ` \\n ${short_title}: ${href}`
    });
const icsInhalt = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${removeHtmlTags(data.title)}
DESCRIPTION:${removeHtmlTags(description)}
DTSTART:${moment(data.start).format("YYYYMMDD")}T000000
DTEND:${moment(data.end).format("YYYYMMDD")}T235959
END:VEVENT
END:VCALENDAR`;
  const blob = new Blob([icsInhalt], { type: "text/calendar" });
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = data.title + ".ics";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export function createMultipleMeetings(data: TransformedEvent[]): void {
  // Termindetails für ganztägigen Termin
  // .ics-Datei erstellen
  let icsInhalt = `BEGIN:VCALENDAR
VERSION:2.0
X-WR-CALNAME:Lexware-Unternehmerkalender`;
  if (!Array.isArray(data)) {
    console.error("Error: The provided data is not an array.");
    return;
  }
  data.forEach((each) => {
    let description = `
 ${each.resource.description.trim()}
      \\n
      \\n
 Mehr Infos finden Sie hier:
  `;
    each.resource.link.forEach((link: string) => {
      let href = link.split("|")[0];
      let short_title = link.split("|")[1];
      description += `\\n ${short_title}: ${href}`
    });

    icsInhalt += `
BEGIN:VEVENT
SUMMARY:${removeHtmlTags(each.title)}
DESCRIPTION:${removeHtmlTags(description)}
DTSTART:${moment(each.start).format("YYYYMMDD")}T000000
DTEND:${moment(each.end).format("YYYYMMDD")}T235959
END:VEVENT`;
  });
  icsInhalt += `
END:VCALENDAR`;
  const blob = new Blob([icsInhalt], { type: "text/calendar" });
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = "UnternehmerKalendar.ics";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
